export const isScaledSelector = (state) => state.getIn(['app', 'canvas', 'scaled']);
